import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=177ee6c1&"
import script from "./RoundButton.vue?vue&type=script&lang=ts&"
export * from "./RoundButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports